import away from 'away';
import moment from 'moment';

export class IdleDetectingService {
    constructor(onUserBackActive) {
        this.idleStart = null;

        const timer = away(10000);

        timer.on('idle', () => {
            this.idleStart = moment();
        });
        timer.on('active', () => {
            onUserBackActive(moment().diff(this.idleStart, 'second'));
        });
    }
}


// WEBPACK FOOTER //
// ./src/modules/shared/services/IdleDetectingService.js